import ReactLoading from "react-loading";
import Loaderstyles from "./loaderStyles.module.css";
const Ls = Loaderstyles;
export const Loader = () => {
    return (
        <div className={Ls.login_layout}>
            <ReactLoading type={"bubbles"} color={"#3D5AD0"} height={150} width={150} />
        </div>
    );
};